import React from 'react';
import logoBlack from '../../../assets/logo-noir.png';

import CONFIG from '../../../config';

import { useSearchParams } from "react-router-dom";
import axios from "axios";
import Link from '@mui/material/Link';


function Verification() {
  const [done, setDone] = React.useState(false);
  const [error, setError] = React.useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const code = searchParams.get("code");


  React.useEffect(() => {
    axios.post(CONFIG.API_URL + '/api/verify_email/' + code, {})
      .then((response) => {
        switch (response.status) {
          case 200:
            setDone(true);
            break;

          default:
            break;
        }
      })
      .catch((e) => {
        let response = e.response;

        if (response === undefined) {
          alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
          return;
        }

        switch (response.status) {
          case 404:
            setError(true);
            break;

          default:
            alert("Oups, une erreur est survenue...\nSi cela persiste, contactez nous directement.");
            break;
        }
      });
  }, []);


  return (
    <>
      <div className='m-6 grid-cols-12 gap-x-4 shrink-0 p-6 max-w-lg mx-auto bg-white my-shadow'>
        <div className='col-start-3 col-span-8 w-full item-center mb-6'>
          <img src={logoBlack} alt="Logo" />
        </div>

        <div className='col-span-12 w-full mb-4 text-center'>
          {!done && !error && <h1>Vérification en cours...</h1>}
          {done && <h1>Votre adresse email est vérifiée</h1>}
          {error && <h1>Ce lien est erroné ou expiré</h1>}
        </div>

        <div className='col-span-12 w-full text-center'>
          {done &&
            <div className='col-start-2 col-span-10 w-full text-center bg-green-200 rounded-md p-2'>
              Vous pouvez maintenant <Link variant='contained' href={CONFIG.BASE_URL + "/connexion"}><span className='text-black underline decoration-black hover:decoration-2'>cliquer ici</span></Link> pour vous connecter.
            </div>
          }
          {error &&

            <div className='col-start-2 col-span-10 w-full text-center bg-red-200 rounded-md p-2'>
              Vous pouvez <Link variant='contained' href={CONFIG.BASE_URL + "/renvoyer_mail"}><span className='text-black underline decoration-black hover:decoration-2'>cliquer ici</span></Link> pour renvoyer un mail de vérification.
            </div>
          }
        </div>
      </div>
    </>
  );
}

export default Verification;